import { z } from 'zod';

import { apiGet, apiPatch, apiPost } from '../client';

export const OnboardingStatusSchema = z.object({
  data: z.object({
    state: z.enum(['draft', 'published']),
    ready: z.boolean(),
    currentStep: z.string(),
    // The API owns the enum. Keeping this client forward-compatible lets it
    // show an honest generic explanation until it learns a newly-added reason.
    blockingReasons: z.array(z.string()),
    counts: z.object({
      menuProducts: z.number(),
      reservationOfferings: z.number(),
      resources: z.number(),
      futureSessions: z.number(),
      prepaySessions: z.number(),
    }).partial().optional(),
  }),
});
export type OnboardingStatus = z.infer<typeof OnboardingStatusSchema>['data'];

export function getOnboarding(): Promise<OnboardingStatus> {
  return apiGet('/v1/business/onboarding', OnboardingStatusSchema).then((result) => result.data);
}

export function saveOnboardingStep(currentStep: string, idempotencyKey: string): Promise<OnboardingStatus> {
  return apiPatch('/v1/business/onboarding', OnboardingStatusSchema, { currentStep }, idempotencyKey).then((result) => result.data);
}

export function publishOnboarding(idempotencyKey: string): Promise<OnboardingStatus> {
  return apiPost('/v1/business/onboarding/publish', OnboardingStatusSchema, undefined, idempotencyKey).then((result) => result.data);
}
